import { jsxs, jsx } from "react/jsx-runtime";
import { IconRenderer, Bleed, Box, Text } from "braid-design-system";
import { BadgeVerifiedCredentials } from "./styles/BadgeVerifiedCredentials/BadgeVerifiedCredentials.mjs";
import { Logo } from "./styles/Logo/Logo.mjs";
const palette = {
  brand: "#4c459c"
};
const IconVerifiedSVG = ({ title, titleId, ...props }) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 52.84 59.59",
    focusable: "false",
    width: 16,
    height: 16,
    "aria-labelledby": titleId,
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", { id: titleId, children: title }) : null,
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: palette.brand,
          d: "M22.83,43.72a.45.45,0,0,1-.29-.09L12,34.85a1.34,1.34,0,0,1-.48-1V24.5a.3.3,0,0,1,.48-.26l10.85,9L48.4,12,28.72.62a4.56,4.56,0,0,0-4.6,0L2.3,13.21a4.61,4.61,0,0,0-2.3,4V42.39a4.63,4.63,0,0,0,2.3,4L24.12,59a4.61,4.61,0,0,0,4.6,0L50.53,46.38a4.62,4.62,0,0,0,2.31-4V18.91L23.12,43.63A.45.45,0,0,1,22.83,43.72Z"
        }
      )
    ]
  }
);
const IconVerified = ({ title, titleId }) => {
  const a11yProps = Boolean(title) ? { title, titleId, role: "img" } : { "aria-hidden": true };
  return /* @__PURE__ */ jsx(IconRenderer, { children: ({ className }) => /* @__PURE__ */ jsx(IconVerifiedSVG, { className, ...a11yProps }) });
};
const SeekPassIconVerifiedSVG = ({
  title,
  titleId,
  darkMode = false,
  ...props
}) => /* @__PURE__ */ jsxs(
  "svg",
  {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId,
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", { id: titleId, children: title }) : null,
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12.49 1.13L21.49 6.13C21.8 6.3 22 6.64 22 7V17C22 17.36 21.81 17.69 21.49 17.87L12.49 22.87C12.33 22.96 12.17 23 12 23C11.83 23 11.66 22.95 11.51 22.87L2.51 17.87C2.2 17.7 2 17.36 2 17V7C2 6.64 2.19 6.31 2.51 6.13L11.52 1.13C11.82 0.960001 12.19 0.960001 12.49 1.13ZM10.9903 15C10.9935 15 10.9968 15 11 15H10.98C10.9834 15 10.9868 15 10.9903 15ZM10.29 14.71C10.4875 14.8976 10.7338 14.9975 10.9903 15C11.2466 14.9976 11.4926 14.9074 11.69 14.71L16.4 10L14.99 8.59L10.99 12.59L8.99 10.59L7.58 12L10.29 14.71Z",
          fill: darkMode ? "#978BDF" : "#503DC9"
        }
      )
    ]
  }
);
const SeekPassIconVerified = ({
  title,
  titleId,
  darkMode = false
}) => {
  const a11yProps = Boolean(title) ? { title, titleId, role: "img" } : { "aria-hidden": true };
  return /* @__PURE__ */ jsx(IconRenderer, { children: ({ className }) => /* @__PURE__ */ jsx(
    SeekPassIconVerifiedSVG,
    {
      className,
      ...a11yProps,
      darkMode
    }
  ) });
};
const verticalPadding = "xxsmall";
const BadgeVerified = ({
  children,
  bleedY = false
}) => {
  const content = /* @__PURE__ */ jsx(Box, { component: "span", display: "flex", cursor: "default", children: /* @__PURE__ */ jsx(
    Box,
    {
      component: "span",
      background: "promoteLight",
      paddingY: verticalPadding,
      paddingX: "xsmall",
      borderRadius: "standard",
      overflow: "hidden",
      children: /* @__PURE__ */ jsxs(Text, { size: "xsmall", weight: "medium", maxLines: 1, children: [
        /* @__PURE__ */ jsx(IconRenderer, { children: ({ className }) => /* @__PURE__ */ jsxs(
          "svg",
          {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "4 2 53 63",
            focusable: "false",
            fill: "currentColor",
            className,
            children: [
              /* @__PURE__ */ jsx(
                "path",
                {
                  fill: "none",
                  d: "M30.42,0a8.69,8.69,0,0,0-4.31,1.15L4.3,13.74A8.65,8.65,0,0,0,0,21.2V46.38a8.63,8.63,0,0,0,4.3,7.45L26.11,66.42a8.57,8.57,0,0,0,8.61,0L56.53,53.83a8.63,8.63,0,0,0,4.3-7.45V21.2a8.65,8.65,0,0,0-4.3-7.46L34.72,1.15A8.68,8.68,0,0,0,30.42,0Z"
                }
              ),
              /* @__PURE__ */ jsx("path", { d: "M26.83,47.71a.38.38,0,0,1-.29-.09L16,38.85a1.38,1.38,0,0,1-.47-1V28.5a.3.3,0,0,1,.48-.26l10.85,9L52.4,16,32.72,4.61a4.63,4.63,0,0,0-4.61,0L6.3,17.21a4.59,4.59,0,0,0-2.3,4V46.38a4.59,4.59,0,0,0,2.3,4L28.11,63a4.63,4.63,0,0,0,4.61,0l21.81-12.6a4.59,4.59,0,0,0,2.3-4V22.9L27.11,47.62A.37.37,0,0,1,26.83,47.71Z" })
            ]
          }
        ) }),
        " ",
        children
      ] })
    }
  ) });
  return bleedY ? /* @__PURE__ */ jsx(Bleed, { component: "span", vertical: verticalPadding, children: content }) : content;
};
BadgeVerified.__isBadge__ = true;
const VerificationLogo = ({
  title = "Verification SEEK Pass Logo"
}) => /* @__PURE__ */ jsxs(
  "svg",
  {
    width: "96",
    height: "100%",
    viewBox: "0 0 72 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ jsx("title", { children: title }),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M48.788 13.4531H23.288C22.1144 13.4531 21.163 14.4045 21.163 15.5781V53.8281C21.163 55.0017 22.1144 55.9531 23.288 55.9531H48.788C49.9616 55.9531 50.913 55.0017 50.913 53.8281V15.5781C50.913 14.4045 49.9616 13.4531 48.788 13.4531Z",
          fill: "#EE399E"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M48.788 9.20312H23.288C19.7672 9.20312 16.913 12.0573 16.913 15.5781V53.8281C16.913 57.349 19.7672 60.2031 23.288 60.2031H48.788C52.3088 60.2031 55.163 57.349 55.163 53.8281V15.5781C55.163 12.0573 52.3088 9.20312 48.788 9.20312ZM50.913 53.8281C50.913 54.9998 49.9597 55.9531 48.788 55.9531H23.288C22.1163 55.9531 21.163 54.9998 21.163 53.8281V15.5781C21.163 14.4064 22.1163 13.4531 23.288 13.4531H48.788C49.9597 13.4531 50.913 14.4064 50.913 15.5781V53.8281Z",
          fill: "#F59BD0"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M46.4849 21.6328H25.5911V23.2266H46.4849V21.6328Z",
          fill: "#F59BD0"
        }
      ),
      /* @__PURE__ */ jsx("path", { d: "M46.4849 26.0312H25.5911V27.625H46.4849V26.0312Z", fill: "#F59BD0" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M44.4927 30.4258H27.5833V32.0195H44.4927V30.4258Z",
          fill: "#F59BD0"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M40.9632 45.3867C40.023 46.6951 38.577 47.6104 36.9094 47.8509L39.3374 52.0563L40.8082 49.861L43.4448 49.6849L40.9632 45.3867Z",
          fill: "#512EAA"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M31.1128 45.3867L28.6312 49.6849L31.2678 49.861L32.7386 52.0563L35.1666 47.8509C33.499 47.6104 32.053 46.6951 31.1128 45.3867Z",
          fill: "#512EAA"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M36.038 35.7891C32.6875 35.7891 29.9713 38.5052 29.9713 41.8557C29.9713 43.1753 30.3972 44.3929 31.1127 45.3885C32.053 46.6969 33.499 47.6121 35.1665 47.8527C35.4518 47.8938 35.7412 47.9223 36.038 47.9223C36.3347 47.9223 36.6241 47.8938 36.9094 47.8527C38.577 47.6121 40.0229 46.6969 40.9632 45.3885C41.6787 44.3929 42.1046 43.1753 42.1046 41.8557C42.1046 38.5052 39.3885 35.7891 36.038 35.7891ZM38.7997 41.5135L37.841 42.5331C37.7716 42.607 37.7387 42.7084 37.7524 42.8093L37.9177 44.0572L37.9361 44.1963C37.9714 44.4621 37.6986 44.6614 37.4563 44.547L37.2433 44.4466L36.1903 43.9505C36.0986 43.9072 35.9918 43.9075 35.9002 43.9513L34.8468 44.4548L34.6376 44.5547C34.3959 44.6705 34.122 44.4727 34.1559 44.2068L34.1738 44.0662L34.332 42.8187C34.3451 42.7178 34.3117 42.6166 34.2415 42.543L33.2775 41.5287C33.093 41.3344 33.1964 41.0131 33.4595 40.9629L34.8344 40.7018C34.9342 40.6825 35.0204 40.6197 35.0685 40.5302L35.7351 39.3002C35.863 39.0645 36.2007 39.0636 36.3298 39.2985L37.0032 40.5248C37.0518 40.6141 37.1384 40.6764 37.2382 40.6951L38.6145 40.9487C38.878 40.9975 38.9831 41.3182 38.7997 41.5135Z",
          fill: "#FDC221"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M38.7997 41.5117C38.9831 41.3164 38.878 40.9957 38.6145 40.9469L37.2382 40.6934C37.1384 40.6746 37.0518 40.6123 37.0032 40.5231L36.3299 39.2968C36.2007 39.0618 35.863 39.0627 35.7351 39.2984L35.0686 40.5284C35.0204 40.6179 34.9342 40.6807 34.8344 40.7L33.4595 40.9611C33.1964 41.0114 33.093 41.3327 33.2775 41.5269L34.2415 42.5413C34.3117 42.6148 34.3451 42.716 34.332 42.817L34.1738 44.0644L34.1559 44.205C34.122 44.471 34.3959 44.6687 34.6376 44.553L34.8468 44.453L35.9003 43.9496C35.9918 43.9058 36.0986 43.9055 36.1903 43.9488L37.2433 44.4449L37.4563 44.5452C37.6986 44.6596 37.9714 44.4603 37.9361 44.1946L37.9177 44.0555L37.7524 42.8075C37.7387 42.7066 37.7716 42.6053 37.841 42.5314L38.7997 41.5117Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M65.49 49.8306L56.49 44.8306C56.19 44.6606 55.82 44.6606 55.52 44.8306L46.51 49.8306C46.19 50.0106 46 50.3406 46 50.7006V60.7006C46 61.0606 46.2 61.4006 46.51 61.5706L55.51 66.5706C55.66 66.6506 55.83 66.7006 56 66.7006C56.17 66.7006 56.33 66.6606 56.49 66.5706L65.49 61.5706C65.81 61.3906 66 61.0606 66 60.7006V50.7006C66 50.3406 65.8 50.0006 65.49 49.8306Z",
          fill: "#503DC9"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M46.51 49.8306L55.52 44.8306C55.82 44.6606 56.19 44.6606 56.49 44.8306L65.49 49.8306C65.8 50.0006 66 50.3406 66 50.7006V60.7006C66 61.0606 65.81 61.3906 65.49 61.5706L56.49 66.5706C56.33 66.6606 56.17 66.7006 56 66.7006C55.83 66.7006 55.66 66.6506 55.51 66.5706L46.51 61.5706C46.2 61.4006 46 61.0606 46 60.7006V50.7006C46 50.3406 46.19 50.0106 46.51 49.8306ZM45.5421 63.3208C44.5848 62.7929 44 61.7763 44 60.7006V50.7006C44 49.6216 44.5767 48.6234 45.5295 48.0875L45.5395 48.0818L54.5439 43.085C55.4506 42.5757 56.56 42.5758 57.4667 43.0853L66.4578 48.0804C67.4152 48.6084 68 49.625 68 50.7006V60.7006C68 61.7797 67.4233 62.7778 66.4705 63.3138L66.4613 63.319L57.4705 68.3138C57.4686 68.3148 57.4667 68.3159 57.4648 68.317C57.0061 68.5737 56.5103 68.7006 56 68.7006C55.4457 68.7006 54.9547 68.5411 54.5688 68.3353L54.5537 68.3273L45.5421 63.3208Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M55 58.6991C54.74 58.6991 54.49 58.5991 54.29 58.4091L51.58 55.6991L52.99 54.2891L54.99 56.2891L58.99 52.2891L60.4 53.6991L55.69 58.4091C55.49 58.6091 55.24 58.6991 54.98 58.6991H55Z",
          fill: "white"
        }
      )
    ]
  }
);
const EducationLogo = ({
  title = "Education SEEK Pass Logo"
}) => /* @__PURE__ */ jsxs(
  "svg",
  {
    width: "96",
    height: "100%",
    viewBox: "0 0 72 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ jsx("title", { children: title }),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M13.498 27.0508V45.132C13.498 50.141 23.2654 54.1998 35.3133 54.1998C47.3613 54.1998 57.1286 50.141 57.1286 45.132V27.0508H13.498Z",
          fill: "#937FEF"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M33.9897 40.2017L5.42762 28.7312C4.85746 28.5005 4.85746 27.6996 5.42762 27.4688L33.9897 15.9984C34.9672 15.6047 36.0532 15.6047 37.0238 15.9984L65.5859 27.4688C66.1561 27.6996 66.1561 28.5005 65.5859 28.7312L37.0238 40.2017C36.0464 40.5954 34.9604 40.5954 33.9897 40.2017Z",
          fill: "#503DC9"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M66.6447 45.459V28.104C66.6447 27.5407 66.1899 27.0859 65.6266 27.0859H35.5101C34.9467 27.0859 34.4919 27.5407 34.4919 28.104C34.4919 28.6674 34.9467 29.1221 35.5101 29.1221H64.6084V45.459C63.2441 45.8934 62.2531 47.1558 62.2531 48.6626V53.2168H69V48.6626C69 47.1558 68.009 45.8934 66.6447 45.459Z",
          fill: "#FDC221"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M67.49 51.8306L58.49 46.8306C58.19 46.6606 57.82 46.6606 57.52 46.8306L48.51 51.8306C48.19 52.0106 48 52.3406 48 52.7006V62.7006C48 63.0606 48.2 63.4006 48.51 63.5706L57.51 68.5706C57.66 68.6506 57.83 68.7006 58 68.7006C58.17 68.7006 58.33 68.6606 58.49 68.5706L67.49 63.5706C67.81 63.3906 68 63.0606 68 62.7006V52.7006C68 52.3406 67.8 52.0006 67.49 51.8306Z",
          fill: "#503DC9"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M48.51 51.8306L57.52 46.8306C57.82 46.6606 58.19 46.6606 58.49 46.8306L67.49 51.8306C67.8 52.0006 68 52.3406 68 52.7006V62.7006C68 63.0606 67.81 63.3906 67.49 63.5706L58.49 68.5706C58.33 68.6606 58.17 68.7006 58 68.7006C57.83 68.7006 57.66 68.6506 57.51 68.5706L48.51 63.5706C48.2 63.4006 48 63.0606 48 62.7006V52.7006C48 52.3406 48.19 52.0106 48.51 51.8306ZM47.5421 65.3208C46.5848 64.7929 46 63.7763 46 62.7006V52.7006C46 51.6216 46.5767 50.6234 47.5295 50.0875L47.5395 50.0818L56.5439 45.085C57.4506 44.5757 58.56 44.5758 59.4667 45.0853L68.4578 50.0804C69.4152 50.6084 70 51.625 70 52.7006V62.7006C70 63.7797 69.4233 64.7778 68.4705 65.3138L68.4613 65.319L59.4705 70.3138C59.4686 70.3148 59.4667 70.3159 59.4648 70.317C59.0061 70.5737 58.5103 70.7006 58 70.7006C57.4457 70.7006 56.9547 70.5411 56.5688 70.3353L56.5537 70.3273L47.5421 65.3208Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M57 60.6991C56.74 60.6991 56.49 60.5991 56.29 60.4091L53.58 57.6991L54.99 56.2891L56.99 58.2891L60.99 54.2891L62.4 55.6991L57.69 60.4091C57.49 60.6091 57.24 60.6991 56.98 60.6991H57Z",
          fill: "white"
        }
      )
    ]
  }
);
const IdentityLogo = ({
  title = "Identity SEEK Pass Logo"
}) => /* @__PURE__ */ jsxs(
  "svg",
  {
    width: "96",
    height: "100%",
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ jsx("title", { children: title }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M9 10.2148C9 9.54604 9.54214 9.00391 10.2109 9.00391H16.3199C16.9886 9.00391 17.5308 9.54604 17.5308 10.2148C17.5308 10.8836 16.9886 11.4257 16.3199 11.4257H11.4218V16.3238C11.4218 16.9925 10.8797 17.5347 10.2109 17.5347C9.54214 17.5347 9 16.9925 9 16.3238V10.2148Z",
          fill: "#4166A4"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M10.2109 54.4688C10.8797 54.4688 11.4218 55.0109 11.4218 55.6796V60.5777H16.3199C16.9886 60.5777 17.5308 61.1199 17.5308 61.7886C17.5308 62.4574 16.9886 62.9995 16.3199 62.9995H10.2109C9.54214 62.9995 9 62.4574 9 61.7886V55.6796C9 55.0109 9.54214 54.4688 10.2109 54.4688Z",
          fill: "#4166A4"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M54.4692 10.2148C54.4692 9.54604 55.0114 9.00391 55.6801 9.00391H61.7891C62.4579 9.00391 63 9.54604 63 10.2148V16.3238C63 16.9925 62.4579 17.5347 61.7891 17.5347C61.1204 17.5347 60.5782 16.9925 60.5782 16.3238V11.4257H55.6801C55.0114 11.4257 54.4692 10.8836 54.4692 10.2148Z",
          fill: "#4166A4"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M45.4258 20H26.5742C22.9434 20 20 22.9434 20 26.5742V45.4258C20 49.0566 22.9434 52 26.5742 52H45.4258C49.0566 52 52 49.0566 52 45.4258V26.5742C52 22.9434 49.0566 20 45.4258 20Z",
          fill: "#EE399E"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M45.2117 47.0609C45.2117 41.9714 41.0864 37.8516 36.0023 37.8516C30.9183 37.8516 26.793 41.9769 26.793 47.0609H45.2172H45.2117Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M40.6043 30.9316C40.6043 33.4737 38.5443 35.5391 35.9968 35.5391C33.4548 35.5391 31.3894 33.4792 31.3894 30.9316C31.3894 28.3841 33.4493 26.3242 35.9968 26.3242C38.5443 26.3242 40.6043 28.3841 40.6043 30.9316Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M67.49 49.1275L58.49 44.1275C58.19 43.9575 57.82 43.9575 57.52 44.1275L48.51 49.1275C48.19 49.3075 48 49.6375 48 49.9975V59.9975C48 60.3575 48.2 60.6975 48.51 60.8675L57.51 65.8675C57.66 65.9475 57.83 65.9975 58 65.9975C58.17 65.9975 58.33 65.9575 58.49 65.8675L67.49 60.8675C67.81 60.6875 68 60.3575 68 59.9975V49.9975C68 49.6375 67.8 49.2975 67.49 49.1275Z",
          fill: "#503DC9"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M48.51 49.1275L57.52 44.1275C57.82 43.9575 58.19 43.9575 58.49 44.1275L67.49 49.1275C67.8 49.2975 68 49.6375 68 49.9975V59.9975C68 60.3575 67.81 60.6875 67.49 60.8675L58.49 65.8675C58.33 65.9575 58.17 65.9975 58 65.9975C57.83 65.9975 57.66 65.9475 57.51 65.8675L48.51 60.8675C48.2 60.6975 48 60.3575 48 59.9975V49.9975C48 49.6375 48.19 49.3075 48.51 49.1275ZM47.5421 62.6177C46.5848 62.0897 46 61.0732 46 59.9975V49.9975C46 48.9184 46.5767 47.9203 47.5295 47.3843L47.5395 47.3787L56.5439 42.3819C57.4506 41.8726 58.56 41.8727 59.4667 42.3822L68.4578 47.3773C69.4152 47.9052 70 48.9218 70 49.9975V59.9975C70 61.0766 69.4233 62.0747 68.4705 62.6107L68.4613 62.6158L59.4705 67.6107C59.4686 67.6117 59.4667 67.6128 59.4648 67.6139C59.0061 67.8706 58.5103 67.9975 58 67.9975C57.4457 67.9975 56.9547 67.838 56.5688 67.6322L56.5537 67.6241L47.5421 62.6177Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M57.0001 57.9959C56.7401 57.9959 56.4901 57.8959 56.2901 57.7059L53.5801 54.9959L54.9901 53.5859L56.9901 55.5859L60.9901 51.5859L62.4001 52.9959L57.6901 57.7059C57.4901 57.9059 57.2401 57.9959 56.9801 57.9959H57.0001Z",
          fill: "white"
        }
      )
    ]
  }
);
const WorkHistoryLogo = ({
  title = "Work History SEEK Pass Logo"
}) => /* @__PURE__ */ jsxs(
  "svg",
  {
    width: "96",
    height: "100%",
    viewBox: "0 0 72 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ jsx("title", { children: title }),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M36.5384 13.0092V8.96875H20.3769V13.0092H16.3365V55.95H40.5788V13.0092H36.5384Z",
          fill: "#EE399E"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M55.6635 21.0938H40.5789V55.9538H55.6635V21.0938Z",
          fill: "#0D3880"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M49.6363 29.1719H46.606C46.3271 29.1719 46.101 29.398 46.101 29.6769V32.7072C46.101 32.9861 46.3271 33.2123 46.606 33.2123H49.6363C49.9152 33.2123 50.1413 32.9861 50.1413 32.7072V29.6769C50.1413 29.398 49.9152 29.1719 49.6363 29.1719Z",
          fill: "#7795C2"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M49.6363 37.2578H46.606C46.3271 37.2578 46.101 37.4839 46.101 37.7629V40.7931C46.101 41.0721 46.3271 41.2982 46.606 41.2982H49.6363C49.9152 41.2982 50.1413 41.0721 50.1413 40.7931V37.7629C50.1413 37.4839 49.9152 37.2578 49.6363 37.2578Z",
          fill: "#7795C2"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M46.101 45.3359H50.1413V48.8713C50.1413 49.15 49.915 49.3763 49.6363 49.3763H46.101V45.3359Z",
          fill: "#7795C2"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M25.9324 21.0938H22.9021C22.6232 21.0938 22.3971 21.3199 22.3971 21.5988V24.6291C22.3971 24.908 22.6232 25.1341 22.9021 25.1341H25.9324C26.2114 25.1341 26.4375 24.908 26.4375 24.6291V21.5988C26.4375 21.3199 26.2114 21.0938 25.9324 21.0938Z",
          fill: "#F8B1DC"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M25.9324 29.1719H22.9021C22.6232 29.1719 22.3971 29.398 22.3971 29.6769V32.7072C22.3971 32.9861 22.6232 33.2123 22.9021 33.2123H25.9324C26.2114 33.2123 26.4375 32.9861 26.4375 32.7072V29.6769C26.4375 29.398 26.2114 29.1719 25.9324 29.1719Z",
          fill: "#F8B1DC"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M25.9324 37.2578H22.9021C22.6232 37.2578 22.3971 37.4839 22.3971 37.7629V40.7931C22.3971 41.0721 22.6232 41.2982 22.9021 41.2982H25.9324C26.2114 41.2982 26.4375 41.0721 26.4375 40.7931V37.7629C26.4375 37.4839 26.2114 37.2578 25.9324 37.2578Z",
          fill: "#F8B1DC"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M34.0132 21.0938H30.983C30.704 21.0938 30.4779 21.3199 30.4779 21.5988V24.6291C30.4779 24.908 30.704 25.1341 30.983 25.1341H34.0132C34.2922 25.1341 34.5183 24.908 34.5183 24.6291V21.5988C34.5183 21.3199 34.2922 21.0938 34.0132 21.0938Z",
          fill: "#F8B1DC"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M34.0132 29.1719H30.983C30.704 29.1719 30.4779 29.398 30.4779 29.6769V32.7072C30.4779 32.9861 30.704 33.2123 30.983 33.2123H34.0132C34.2922 33.2123 34.5183 32.9861 34.5183 32.7072V29.6769C34.5183 29.398 34.2922 29.1719 34.0132 29.1719Z",
          fill: "#F8B1DC"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M34.0132 37.2578H30.983C30.704 37.2578 30.4779 37.4839 30.4779 37.7629V40.7931C30.4779 41.0721 30.704 41.2982 30.983 41.2982H34.0132C34.2922 41.2982 34.5183 41.0721 34.5183 40.7931V37.7629C34.5183 37.4839 34.2922 37.2578 34.0132 37.2578Z",
          fill: "#F8B1DC"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M25.9324 45.3359H22.9021C22.6232 45.3359 22.3971 45.5621 22.3971 45.841V48.8713C22.3971 49.1502 22.6232 49.3763 22.9021 49.3763H25.9324C26.2114 49.3763 26.4375 49.1502 26.4375 48.8713V45.841C26.4375 45.5621 26.2114 45.3359 25.9324 45.3359Z",
          fill: "#F8B1DC"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M34.0132 45.3359H30.983C30.704 45.3359 30.4779 45.5621 30.4779 45.841V48.8713C30.4779 49.1502 30.704 49.3763 30.983 49.3763H34.0132C34.2922 49.3763 34.5183 49.1502 34.5183 48.8713V45.841C34.5183 45.5621 34.2922 45.3359 34.0132 45.3359Z",
          fill: "#F8B1DC"
        }
      ),
      /* @__PURE__ */ jsx("path", { d: "M58.222 55.9531H13.7778V60.2031H58.222V55.9531Z", fill: "#B6C7E0" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M65.49 49.8306L56.49 44.8306C56.19 44.6606 55.82 44.6606 55.52 44.8306L46.51 49.8306C46.19 50.0106 46 50.3406 46 50.7006V60.7006C46 61.0606 46.2 61.4006 46.51 61.5706L55.51 66.5706C55.66 66.6506 55.83 66.7006 56 66.7006C56.17 66.7006 56.33 66.6606 56.49 66.5706L65.49 61.5706C65.81 61.3906 66 61.0606 66 60.7006V50.7006C66 50.3406 65.8 50.0006 65.49 49.8306Z",
          fill: "#503DC9"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M46.51 49.8306L55.52 44.8306C55.82 44.6606 56.19 44.6606 56.49 44.8306L65.49 49.8306C65.8 50.0006 66 50.3406 66 50.7006V60.7006C66 61.0606 65.81 61.3906 65.49 61.5706L56.49 66.5706C56.33 66.6606 56.17 66.7006 56 66.7006C55.83 66.7006 55.66 66.6506 55.51 66.5706L46.51 61.5706C46.2 61.4006 46 61.0606 46 60.7006V50.7006C46 50.3406 46.19 50.0106 46.51 49.8306ZM45.5421 63.3208C44.5848 62.7929 44 61.7763 44 60.7006V50.7006C44 49.6216 44.5767 48.6234 45.5295 48.0875L45.5395 48.0818L54.5439 43.085C55.4506 42.5757 56.56 42.5758 57.4667 43.0853L66.4578 48.0804C67.4152 48.6084 68 49.625 68 50.7006V60.7006C68 61.7797 67.4233 62.7778 66.4705 63.3138L66.4613 63.319L57.4705 68.3138C57.4686 68.3148 57.4667 68.3159 57.4648 68.317C57.0061 68.5737 56.5103 68.7006 56 68.7006C55.4457 68.7006 54.9547 68.5411 54.5688 68.3353L54.5537 68.3273L45.5421 63.3208Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M55 58.6991C54.74 58.6991 54.49 58.5991 54.29 58.4091L51.58 55.6991L52.99 54.2891L54.99 56.2891L58.99 52.2891L60.4 53.6991L55.69 58.4091C55.49 58.6091 55.24 58.6991 54.98 58.6991H55Z",
          fill: "white"
        }
      )
    ]
  }
);
export {
  BadgeVerified,
  BadgeVerifiedCredentials,
  EducationLogo,
  IconVerified,
  IdentityLogo,
  Logo,
  SeekPassIconVerified,
  VerificationLogo,
  WorkHistoryLogo,
  palette
};
